import Profile from './Profile'

const DesktopSection = () => <Profile />

export default DesktopSection
